import { GeoZones } from '@EcamModel/model';
import { Box, Stack, Table, TableBody, TableHead, TableRow, Typography } from '@mui/material';
import ListNoData from '@pages/cameras/list/components/NoDataCameras';
import { BaseHead, CellOfRow } from '@components/tables';
import { groupBy } from 'lodash';
import moment from 'moment';
import theme from '@theme/Theme';
import { convertSecondsToDate } from '@utils/functions';
import { formatSecondsToHHMMSS } from '@pages/cameras/details/utils';
import { formatUKDate } from 'src/helpers';

type Props = {
    geoZones?: GeoZones[];
};
export default function PCGeoZonesDetail(props: Props) {
    const { geoZones } = props;

    return (
        <>
            {!geoZones?.length ? (
                <ListNoData
                    sx={{
                        border: 'none',
                        minHeight: 200,
                    }}
                />
            ) : (
                <Table aria-label="simple table" sx={{ m: 2, width: '98%' }}>
                    <TableHead>
                        <TableRow>
                            <CellOfRow
                                value={
                                    <Typography fontSize={16} fontWeight={500}>
                                        Geo-zone
                                    </Typography>
                                }
                                align="center"
                            />
                            <CellOfRow
                                value={
                                    <Typography fontSize={16} fontWeight={500}>
                                        Operation period
                                    </Typography>
                                }
                                align="left"
                            />
                            <CellOfRow
                                value={
                                    <Typography fontSize={16} fontWeight={500}>
                                        Contravention type
                                    </Typography>
                                }
                                align="center"
                            />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {geoZones?.map((item, index) => {
                            const operationHoursConfigs = item.GZOConfigs?.[0];

                            const operationHours = operationHoursConfigs?.GZOConfigGracePeriods.flatMap((item) =>
                                item.GZOConfigDays.map((item) => item)
                            );

                            const _operationHours = groupBy(operationHours, 'Weekday');

                            return (
                                <TableRow
                                    key={`${index}+1`}
                                    sx={{
                                        verticalAlign: !!operationHoursConfigs?.EffectiveFrom ? 'top' : 'middle',
                                    }}
                                >
                                    <CellOfRow value={index + 1} align="center" />
                                    <CellOfRow
                                        align="left"
                                        value={
                                            <Stack>
                                                {!!operationHoursConfigs?.EffectiveFrom ? (
                                                    <Typography color="#256428">
                                                        Effective from:{' '}
                                                        {formatUKDate(operationHoursConfigs?.EffectiveFrom)}
                                                    </Typography>
                                                ) : (
                                                    <Typography fontStyle="italic" color={theme.palette.grey[600]}>
                                                        No current operation hours
                                                    </Typography>
                                                )}
                                                {Object.entries(_operationHours).map(([key, value], index) => {
                                                    return (
                                                        <Stack
                                                            key={index}
                                                            direction="row"
                                                            alignItems="flex-start"
                                                            spacing={1}
                                                            mb={1}
                                                        >
                                                            <Typography minWidth={80}>
                                                                {moment().isoWeekday(parseInt(key)).format('dddd')}
                                                            </Typography>
                                                            <Stack>
                                                                {value.map((o) => {
                                                                    const geoZoneConfig =
                                                                        operationHoursConfigs?.GZOConfigGracePeriods.find(
                                                                            (p) =>
                                                                                p.Id ===
                                                                                o.GeoZoneOperationConfigGracePeriodId
                                                                        );
                                                                    return (
                                                                        <Stack
                                                                            direction="row"
                                                                            alignItems="center"
                                                                            spacing={0.5}
                                                                            pr={2}
                                                                        >
                                                                            <Box
                                                                                sx={{
                                                                                    p: 0.4,
                                                                                    background: '#256428',
                                                                                    borderRadius: 1,
                                                                                }}
                                                                            />
                                                                            <Typography color="GrayText">
                                                                                {moment(
                                                                                    convertSecondsToDate(o.From!)
                                                                                ).format('HH:mm')}
                                                                                -
                                                                                {moment(
                                                                                    convertSecondsToDate(o.To!)
                                                                                ).format('HH:mm')}{' '}
                                                                                | Grace period:{' '}
                                                                                {geoZoneConfig?.GracePeriod != null ? formatSecondsToHHMMSS(geoZoneConfig?.GracePeriod) : '-'}
                                                                            </Typography>
                                                                        </Stack>
                                                                    );
                                                                })}
                                                            </Stack>
                                                        </Stack>
                                                    );
                                                })}
                                            </Stack>
                                        }
                                    />
                                    <CellOfRow
                                        value={item.ContraventionReason?.ContraventionReasonTranslations?.[0]?.Summary!}
                                        align="center"
                                    />
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            )}
        </>
    );
}
